import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/styles/common.less'
import '@/styles/personal.less'
import '@/utils/element-ui'
import '@/utils/vant-ui'

// import '@/utils/checkLoginStatus'

Vue.config.productionTip = false

// 全局注册组件
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
